import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./Spinner.css";

const UpdatePackagePriceModal = ({ isOpen, onRequestClose, packageId }) => {
  const navigate = useNavigate();
  const [price, setPrice] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!price || parseFloat(price) <= 0) {
      toast.error("Please enter a valid price.");
      return;
    }

    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;

    try {
      const today = new Date();
      const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

      const requestBody = {
        packageId: packageId,
        price: parseFloat(price),
        date: formattedDate
      };

      await axios.post(`/api/labPackagePrice/create`, requestBody, {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      toast.success("Package price updated successfully");
      onRequestClose();
      setPrice("");
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handlePriceChange = (e) => {
    const { value } = e.target;
    setPrice(value);
  };

  const handleClose = () => {
    setPrice("");
    onRequestClose();
  };

  return (
    <Modal show={isOpen} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Package Price</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <div className="loading"></div>}
        <div className="col-xl-12 mx-xl-auto">
          <div className="card card-raised mb-3">
            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="price">
                      New Price <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      className="form-control"
                      id="price"
                      type="number"
                      step="0.01"
                      min="0"
                      placeholder="Enter new price"
                      value={price}
                      onChange={handlePriceChange}
                      required
                    />
                  </div>
                </div>

                <div className="d-flex gap-2 mt-3">
                  <Button 
                    type="submit" 
                    variant="primary"
                    disabled={loading}
                  >
                    Update Price
                  </Button>
                  <Button 
                    variant="secondary" 
                    onClick={handleClose}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default UpdatePackagePriceModal;
